import { render, staticRenderFns } from "./familyFooter.vue?vue&type=template&id=34ee3190&scoped=true"
import script from "./familyFooter.vue?vue&type=script&lang=js"
export * from "./familyFooter.vue?vue&type=script&lang=js"
import style0 from "./familyFooter.vue?vue&type=style&index=0&id=34ee3190&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ee3190",
  null
  
)

export default component.exports